import lazyload from "@/lazyload";

export default () => {

  let button = $('.view-more-button');
  let prevText = button.text();

  button.on('click', function (e) {
    if (button.attr("disabled") == "disabled") {
      e.preventDefault();
      return false;
    }

    button.attr("disabled", "disabled");
    button.text("Cargando ...");

    $.ajax({
      url: $(this).attr('data-href')
    })
      .done(function (response) {
        button.text(prevText);
        button.removeAttr("disabled");


        let list = button.closest('.automatic-list').find('.view-more-results');

        if (list.length === 0) {
          const node = document.createElement('div');
          node.innerHTML = response.html;
          document.getElementById('view-more-results').appendChild(node);
        } else {
          list.append(response.html);
        }

        lazyload.update();
        if (response.nextPage != null && response.nextPage !== "") {
          button.attr('data-href', response.nextPage);
        } else {
          button.hide();
        }
      })
  })
}
